// src/pages/public/BlogPostPage.jsx
import { useParams, Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Calendar, ArrowLeft } from 'lucide-react'
import { cmsPublicApi as cmsApi } from '../../api/services'
import { PageSpinner } from '../../components/common/ui'

export default function BlogPostPage() {
  const { slug } = useParams()
  const { data, isLoading } = useQuery({ queryKey: ['blog-post', slug], queryFn: () => cmsApi.post(slug) })

  if (isLoading) return <PageSpinner />
  const payload = data?.data?.data || data?.data
  const page = payload?.page
  const related = payload?.related || []

  if (!page) return <div className="py-24 text-center text-muted">Post not found.</div>

  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-muted hover:text-pink mb-6">
        <ArrowLeft size={14} /> Back to Blog
      </Link>

      <h1 className="text-3xl font-display font-bold text-gray-900 leading-tight mb-3">{page.title}</h1>

      <div className="flex items-center gap-2 text-xs text-muted mb-6">
        <Calendar size={12} />
        {page.published_at ? new Date(page.published_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' }) : ''}
        {page.author_name && <><span>·</span><span>by {page.author_name}</span></>}
      </div>

      {page.featured_image && (
        <div className="rounded-2xl overflow-hidden mb-8">
          <img src={page.featured_image} alt={page.title} className="w-full h-auto max-h-80 object-cover" />
        </div>
      )}

      <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: page.body }} />

      {related.length > 0 && (
        <div className="mt-12 border-t border-border pt-8">
          <h2 className="text-lg font-display font-bold text-gray-900 mb-4">More Articles</h2>
          <div className="grid sm:grid-cols-3 gap-4">
            {related.map(r => (
              <Link key={r.id} to={`/blog/${r.slug}`} className="group">
                {r.featured_image && <div className="aspect-video rounded-xl overflow-hidden mb-2"><img src={r.featured_image} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" /></div>}
                <p className="text-sm font-bold text-gray-900 group-hover:text-pink line-clamp-2">{r.title}</p>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
